export const CREATE_ORDER = "CREATE_ORDER";
export const CREATE_ORDER_FAILURE = "CREATE_ORDER_FAILURE";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";

export const CREATE_ORDER_COD = "CREATE_ORDER_COD";
export const CREATE_ORDER_COD_FAILURE = "CREATE_ORDER_COD_FAILURE";
export const CREATE_ORDER_COD_SUCCESS = "CREATE_ORDER_COD_SUCCESS";

export const CONFIRM_ORDER = "CONFIRM_ORDER";
export const CONFIRM_ORDER_FAILURE = "CONFIRM_ORDER_FAILURE";
export const CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS";

export const APPLY_COUPON = "APPLY_COUPON";
export const APPLY_COUPON_FAILURE = "APPLY_COUPON_FAILURE";
export const APPLY_COUPON_SUCCESS = "APPLY_COUPON_SUCCESS";

export const FETCH_ORDER = "FETCH_ORDER";
export const FETCH_ORDER_FAILURE = "FETCH_ORDER_FAILURE";
export const FETCH_ORDER_SUCCESS = "FETCH_ORDER_SUCCESS";

export const FETCH_ORDERS = "FETCH_ORDERS";
export const FETCH_ORDERS_FAILURE = "FETCH_ORDERS_FAILURE";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";

export const RESET_ORDER_STATE = "RESET_ORDER_STATE";